import { MessagesActionTypes } from './messages-actions';
import { MessagesReducerTypes, MessagesAction } from './messages';

const initialState: MessagesReducerTypes = {
  list: [],
  loading: true,
  currentPage: 1,
  limit: 15,
  lastPage: 0,
  total: 0,
  markAsReadList: [],
  extendedListLoading: false,
};

function messagesReducer(state = initialState, action: MessagesAction): MessagesReducerTypes {
  switch (action.type) {
    case MessagesActionTypes.GET_MESSAGES_LIST:
      return {
        ...state,
        loading: true,
        markAsReadList: initialState.markAsReadList,
        list: initialState.list,
        currentPage: initialState.currentPage,
      };

    case MessagesActionTypes.SET_MESSAGES_LIST:
      const newMessages = action.data?.data || [];
      return {
        ...state,
        list: [...state.list, ...newMessages],
        loading: false,
        limit: action.data?.per_page || state.limit,
        currentPage: (action.data?.current_page ? parseInt(action.data.current_page.toString()) : 0) + 1,
        lastPage: action.data?.last_page || state.lastPage,
        total: action.data?.total || state.total,
        markAsReadList: initialState.markAsReadList,
        extendedListLoading: false,
      };

    case MessagesActionTypes.SET_INITIAL_STATE:
      return initialState;

    case MessagesActionTypes.SET_MESSAGES_AS_READ:
      return {
        ...state,
        markAsReadList: action.data?.ids || [],
        currentPage: Math.max(1, state.currentPage - 1),
        loading: true,
      };

    case MessagesActionTypes.GET_EXTENDED_MESSAGE_LIST:
      return {
        ...state,
        extendedListLoading: true,
      };

    default:
      return state;
  }
}

export default messagesReducer;
